import React, { useState } from 'react';
import TransferList from '../components/TransferList'; // Assuming a TransferList will be created later
import TransferForm from '../components/TransferForm';
import useWindowWidth from '../hooks/useWindowWidth';
import '../components/RevenueDesktop.css';

function TransfersPage() {
  const [editingTransfer, setEditingTransfer] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const width = useWindowWidth();

  const handleEdit = (transfer) => {
    setEditingTransfer(transfer);
    setShowForm(true);
  };

  const handleNewTransfer = () => {
    setEditingTransfer(null);
    setShowForm(true);
  };

  const handleSuccess = () => {
    setShowForm(false);
    setEditingTransfer(null);
    // Optionally, refresh the transfer list here if it's not handled by a global state
  };

  const isDesktop = width >= 768;

  return (
    <div>
      {/* ── Desktop header ── */}
      {isDesktop && !showForm && (
        <div className="rv-page-header">
          <div className="rv-page-header-title">
            <h1>Transferências</h1>
            <p>Gerencie suas transferências entre contas</p>
          </div>
          <button className="rv-btn rv-btn-primary" onClick={handleNewTransfer}>
            + Nova Transferência
          </button>
        </div>
      )}

      {/* ── Mobile header (mantido exatamente como era) ── */}
      {!isDesktop && <h1>Gerenciamento de Transferências</h1>}
      {!isDesktop && !showForm && (
        <button className="btn btn-success mb-3" onClick={handleNewTransfer}>Realizar Nova Transferência</button>
      )}

      {showForm ? (
        <div>
          {isDesktop
            ? <p className="rv-form-heading">{editingTransfer ? 'Editar Transferência' : 'Nova Transferência'}</p>
            : <h2>{editingTransfer ? 'Editar Transferência' : 'Realizar Nova Transferência'}</h2>
          }
          <TransferForm transfer={editingTransfer} onSuccess={handleSuccess} />
          <button className="btn btn-secondary mt-3" onClick={() => setShowForm(false)}>Cancelar</button>
        </div>
      ) : (
        <TransferList onEdit={handleEdit} /> // Assuming a TransferList will be created later
      )}
    </div>
  );
}

export default TransfersPage;
